// extracted by mini-css-extract-plugin
export default {"accordion":"AccordionMethod_accordion__wkGbx","box":"AccordionMethod_box__xadMA","open":"AccordionMethod_open__bkXXy"};